import { TAuthToken } from '@cockpitai/integration/auth/types'
import { StateCreator } from 'zustand'

export interface IAuthSlice {
  auth: TAuthToken | null
  setAuth(auth: TAuthToken | null): void
}

export const createAuthSlice: StateCreator<IAuthSlice, [], [], IAuthSlice> = (
  set,
) => ({
  auth: null,
  setAuth: (auth: TAuthToken | null) => set(() => ({ auth })),
})
